import type { PickerItemValue } from "@design-system/Picker/Picker.types";

/**
 * The one row a multi-select change toggled: the value `next` added, else the
 * value it dropped. For filters whose rows do not map 1:1 onto the filter
 * value and so must apply a per-row toggle instead of storing `next`.
 */
export const findToggledValue = <T extends PickerItemValue>(
    previous: readonly T[],
    next: readonly T[],
): T | undefined =>
    next.find((value) => !previous.includes(value)) ??
    previous.find((value) => !next.includes(value));
